export default {
    setRoles(state, data) {
        state.roles = data
    },
    setDefaults(state, data) {
        state.defaults = data
    },
    setLoading(state, value) {
        state.loading = value
    },
    updateRolePermissions(state, { roleId, permissions }) {
        const role = state.roles.find((r) => r.id === roleId)
        if (role) {
            role.permissions = permissions
        }
    },
    updateRolePermission(state, { roleId, perm, enabled }) {
        const role = state.roles.find((r) => r.id === roleId)
        if (!role) return
        const index = role.permissions.indexOf(perm)
        if (enabled && index === -1) {
            role.permissions.push(perm)
        } else if (!enabled && index > -1) {
            role.permissions.splice(index, 1)
        }
    }
}
